import React, { useState } from 'react';
import { Map, Marker, Draggable } from 'pigeon-maps';

const GATSBY_MAPBOX_ACCESS_TOKEN = process.env.GATSBY_MAPBOX_ACCESS_TOKEN || "";
const GATSBY_MAPBOX_URL = "lececil123/cm1quujef00gt01pl4616glxy";

const getMapProvider =
  (mapStyle: string) => (x: number, y: number, z: number, dpr: number) =>
    `https://api.mapbox.com/styles/v1/${mapStyle}/tiles/512/${z}/${x}/${y}${
      dpr >= 2 ? "@2x" : ""
    }?access_token=${GATSBY_MAPBOX_ACCESS_TOKEN}`;

interface SimpleMapProps {
  latitude: number;
  longitude: number;
  zoom: number;
  onMarkerDragEnd?: (lat: number, lng: number) => void;
}

const SimpleMap: React.FC<SimpleMapProps> = ({ latitude, longitude, zoom, onMarkerDragEnd }) => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <Map 
      provider={getMapProvider(GATSBY_MAPBOX_URL)}
      center={[latitude, longitude]} 
      zoom={zoom}
      draggable={!isDragging} // Disable map dragging when Draggable is active
    >
      {onMarkerDragEnd && (
        <Draggable 
          key={`${latitude}-${longitude}`}
          offset={[0, 0]} 
          anchor={[latitude, longitude]} 
          onDragStart={(e) => {
            e.stopPropagation();
            setIsDragging(true);
          }}
          onDragEnd={(anchor) => {
            setIsDragging(false);
            if (onMarkerDragEnd && anchor) {
              onMarkerDragEnd(anchor[0], anchor[1]);
            }
          }}
          onDragMove={() => {}} // Provide an empty function to satisfy internal checks
        >
          <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'blue', border: '2px solid white' }} />
        </Draggable>
      )}
    </Map>
  );
};

export default SimpleMap;